import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { errorMonitor } from "events";
import { ConfirmationService, MessageService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { CommonResponse, InvoiceMailDTO } from "src/app/interfaces/home";
import { InvoiceService } from "src/app/services/invoice.sevice";
import { UtilService } from "src/app/services/util.service";
import domtoimage from "dom-to-image";
import { jsPDF } from "jspdf";
import { AccountMasterService } from "src/app/services/account-master";

@Component({
  selector: "app-view-note-details",
  templateUrl: "./view-note-details.component.html",
  styleUrls: ["./view-note-details.component.scss"],
})
export class ViewNoteDetailsComponent implements OnInit {
  noteDetails: any;
  noteMaster: any;
  fetchingInvoiceDetails: boolean;
  isGroupedAdhoc = false;
  label = "Credit";
  amountInWords: string = "";
  VAT;
  subTotal: number = 0;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private invoiceService: InvoiceService,
    public modalConfig: DynamicDialogConfig,
    private viewInvoiceModalRef: DynamicDialogRef,
    public utilService: UtilService,
    private accountMasterService: AccountMasterService
  ) {}

  ngOnInit(): void {
    this.fetchingInvoiceDetails = false;
    if (this.modalConfig.data.note) {
      this.noteMaster = this.modalConfig.data.note;
      this.label = this.modalConfig.data.label;
    }
    //this.fetchNoteDetails(this.noteMaster);
    this.putAmountInWords();
  }

  printPage() {
    window.print();
  }

  private putAmountInWords() {
    this.subTotal = this.noteMaster.reduce((a, b) => {
      return a + b.value;
    }, 0);

    let koboPart = 0;
    let doubleAmt = this.subTotal.toString();
    var splitAmt = doubleAmt.split(".");
    var nairaPart = parseInt(splitAmt[0]);
    this.amountInWords = this.utilService.NumberToWords(nairaPart) + " Naira";
    if (splitAmt.length > 1) {
      koboPart = parseInt(splitAmt[1]);
      if (koboPart > 0) {
        this.amountInWords +=
          " " + this.utilService.NumberToWords(koboPart) + " Kobo";
      }
    }
  }

  pdfDownloadPage() {
    var node = document.getElementById("parentdiv");
    var img;
    var filename;
    var newImage;
    domtoimage
      .toPng(node, { bgcolor: "#fff" })
      .then(function (dataUrl) {
        img = new Image();
        img.src = dataUrl;
        newImage = img.src;
        img.onload = function () {
          var pdfWidth = img.width;
          var pdfHeight = img.height;
          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
          var doc;
          if (pdfWidth > pdfHeight) {
            doc = new jsPDF("l", "px", [pdfWidth, pdfHeight]);
          } else {
            doc = new jsPDF("p", "px", [pdfWidth, pdfHeight]);
          }
          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();

          doc.addImage(newImage, "PNG", 10, 10, width, height);
          filename = "invoice" + ".pdf";
          doc.save(filename);
        };
      })
      .catch(function (error) {
        // Error Handling
      });
  }

  sendInvoice(invoiceId: number) {
    this.messageService.add({
      severity: "info",
      summary: "Notice",
      detail: "Sending Invoice",
    });

    this.invoiceService.sendInvoice(invoiceId).subscribe(
      async (res: CommonResponse) => {
        var response = res.responseData as boolean;
        if (response)
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "Invoice Sent",
          });
      },
      (error) => {
        this.messageService.add({
          severity: "errorr",
          summary: "Failed",
          detail: error.error.message,
        });
      }
    );
  }

  confirmSendEmail(invoiceId: number) {
    this.viewInvoiceModalRef.close();
    this.confirmationService.confirm({
      message: "Are you sure you want to send this invoice ?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.sendInvoice(invoiceId);
      },
      reject: (type) => {
        this.messageService.add({
          severity: "error",
          summary: "Rejected",
          detail: "Declined Sending Invoice",
        });
      },
    });
  }

  fetchNoteDetails(id: number) {
    this.messageService.add({
      severity: "info",
      summary: "Notice",
      detail: "Fetching Details",
    });

    this.accountMasterService.getNoteDetail(id).subscribe(
      async (r: CommonResponse) => {
        var det = r.responseData;
        this.VAT = 0;

        // for (let index = 0; index < det.length; index++) {
        //   var data = det[index];
        //   if (data.account?.controlAccount?.caption?.toLowerCase() == "vat") {
        //     this.VAT = data.credit > 0 ? data.credit : data.debit;
        //   }
        // }

        // let koboPart = 0;
        // let amount = this.noteMaster.value.toFixed(2);
        // let doubleAmt = amount.toString();
        // var splitAmt = doubleAmt.split(".");
        // var nairaPart = parseInt(splitAmt[0]);
        // this.amountInWords =
        //   this.utilService.NumberToWords(nairaPart) + " Naira";
        // if (splitAmt.length > 1) {
        //   koboPart = parseInt(splitAmt[1]);
        //   if (koboPart > 0) {
        //     this.amountInWords +=
        //       " " + this.utilService.NumberToWords(koboPart) + " Kobo";
        //   }
        // }

        this.fetchingInvoiceDetails = false;
        this.messageService.add({
          severity: "success",
          summary: "Successful",
          detail: "Successfully fetched note details",
        });
      },
      (error) => {
        this.messageService.add({
          severity: "errorr",
          summary: "Failed",
          detail: error.error.message,
        });
        this.fetchingInvoiceDetails = false;
      }
    );
  }
}
